export default __webpack_public_path__ + "assets/add_photo.24048cd2.png";